import React from 'react';
import { DatePicker } from 'rsuite';
import { PeriodType, DatePeriod } from '@/types/primaryLedgerSnapshots';
import { format } from 'date-fns';

interface PeriodJumpSelectorProps {
  periodType: PeriodType;
  period: DatePeriod;
  onJump: (date: Date) => void;
}

const PeriodJumpSelector: React.FC<PeriodJumpSelectorProps> = ({
  periodType,
  period,
  onJump
}) => {
  const getPeriodLabel = (): string => {
    if (periodType === 'daily') {
      return format(period.startDate, 'MMM d, yyyy');
    } else if (periodType === 'weekly') {
      const weekStart = format(period.startDate, 'MMM d');
      const weekEnd = format(period.endDate, 'MMM d, yyyy');
      return `${weekStart} - ${weekEnd}`;
    } else {
      return format(period.startDate, 'MMMM yyyy');
    }
  };

  return (
    <DatePicker
      value={period.startDate}
      onChange={(date) => {
        if (date) {
          onJump(date);
        }
      }}
      placeholder={getPeriodLabel()}
      format={periodType === 'monthly' ? 'MMMM yyyy' : 'MMM dd, yyyy'}
      cleanable={false}
      className="w-48"
    />
  );
};

export default PeriodJumpSelector;